import DefaultValues from "./components/DefaultValues";
import PriceModal from "./components/PriceModal";

function Settings() {
  return (
    <div style={{ height: "80vh", display: "flex", flexWrap: "wrap" }}>
      <PriceModal />
      <DefaultValues />
    </div>
  );
}

export default Settings;
